module.exports = __webpack_public_path__ + "85293d118dddcae20562cc6a9cb89642.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-account-type/sp-account-type.html
// module id = 1081
// module chunks = 0